export const formatOnlyAllowNumber = (str: string) => parseFloat(str.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'))